import { createContext, useContext, useEffect, useState } from "react";

import { enumProveedorStep } from "../settings/enumConfig";
import { getActividadEconomicaModel } from "../model/giroPrincipalMode";
import { useActividadesEconomicas } from "./ActividadesEconomicasContext";
import { useProveedoresProspectos } from "./ProveedoresProspectosContext";

export const GiroPrincipalContext = createContext();

export const GiroPrincipalProvider = (props) => {
    const { lstActividadesCatalogo } = useActividadesEconomicas();
    const { entSolicitudDetalleForEdit, handleChangeStep, handleClickResetStepError } = useProveedoresProspectos();

    const [actividadSeleccionada, setActividadSeleccionada] = useState(getActividadEconomicaModel());
    const [actividadPreseleccionada, setActividadPreseleccionada] = useState(getActividadEconomicaModel());

    const [lstActividadesSecundariasSeleccionadas, setLstActividadesSecundariasSeleccionadas] = useState([]);
    const [actividadSecudariaEliminar, setActividadSecudariaEliminar] = useState(null);

    const [modalOpenAsignar, setModalOpenAsignar] = useState(false);
    const [modalOpenEliminarGiro, setModalOpenEliminarGiro] = useState(false);
    const [modalOpenEliminarActividadSecundaria, setModalOpenEliminarActividadSecundaria] = useState(false);
    const [modalOpenContinuarSinAdicionales, setModalOpenContinuarSinAdicionales] = useState(false);

    const [actividadCatalogoSeleccionado, setActividadCatalogoSeleccionado] = useState(null);

    const handleCloseAsignar = () => {
        setModalOpenAsignar(false);
    };

    const handleCloseEliminarGiro = () => {
        setModalOpenEliminarGiro(false);
    };

    const handleCloseEliminarActividadSecundaria = () => {
        setModalOpenEliminarActividadSecundaria(false);
    };

    const handleCloseContinuarSinAdicionales = () => {
        setModalOpenContinuarSinAdicionales(false);
    };

    const handleChangeActividadCatalogoSeleccionado = (e, value) => {
        setActividadCatalogoSeleccionado(value);
    };

    const handleChangeActividadPreseleccionada = (value) => {
        setActividadPreseleccionada(value);
    };

    const handleClickAsignarActividad = () => {
        setModalOpenAsignar(true);
    };

    const handleClickConfirmarAsignar = () => {
        setActividadSeleccionada(actividadPreseleccionada);
        setModalOpenAsignar(false);
    };

    const handleClickEliminarGiro = () => {
        setModalOpenEliminarGiro(true);
    };

    const handleClickConfirmarEliminarGiro = () => {
        setActividadSeleccionada(getActividadEconomicaModel());
        setModalOpenEliminarGiro(false);
    };

    const handleClickEliminarActividadSecundaria = (actividad) => {
        setActividadSecudariaEliminar(actividad);
        setModalOpenEliminarActividadSecundaria(true);
    };

    const handleClickConfirmarEliminarActividadSecundaria = () => {
        if (!actividadSecudariaEliminar) {
            return;
        }
        setLstActividadesSecundariasSeleccionadas(
            lstActividadesSecundariasSeleccionadas.filter((x) => x.iIdUnspscJoinEsEn !== actividadSecudariaEliminar.iIdUnspscJoinEsEn)
        );
        setModalOpenEliminarActividadSecundaria(false);
    };

    const handleClickAgregarActividadCatalogo = () => {
        if (!actividadCatalogoSeleccionado || lstActividadesSecundariasSeleccionadas.length >= 4) {
            return;
        }

        const index = lstActividadesSecundariasSeleccionadas.indexOf(actividadCatalogoSeleccionado);
        if (index === -1) {
            const nuevaLista = [...lstActividadesSecundariasSeleccionadas, actividadCatalogoSeleccionado];
            setLstActividadesSecundariasSeleccionadas(nuevaLista);

            setActividadCatalogoSeleccionado(null);
        }
    };

    const handleClickSiguiente = () => {
        if (lstActividadesSecundariasSeleccionadas.length === 0) {
            setModalOpenContinuarSinAdicionales(true);
        } else {
            handleChangeStep(enumProveedorStep.DomicilioFiscal);
        }
    };

    const handleClickConfirmarContinuarSinAdicionales = () => {
        setModalOpenContinuarSinAdicionales(false);
        handleChangeStep(enumProveedorStep.DomicilioFiscal);
    };

    const handleClickRegresar = () => {
        handleChangeStep(enumProveedorStep.DatosCompania);
        handleClickResetStepError();
    };

    const fnFillFormGiroPrinicpal = () => {
        if (!entSolicitudDetalleForEdit) {
            return;
        }

        const {
            entGiroPrincipal: { entActividadPrincipal, lstActividadesAdicionales },
        } = entSolicitudDetalleForEdit;

        const lstIDActividadesAdicionales = lstActividadesAdicionales.map((x) => x.iIdUnspscJoinEsEn);

        const activiadesAdicionalesSeleccionadas = lstActividadesCatalogo.filter((x) =>
            lstIDActividadesAdicionales.includes(x.iIdUnspscJoinEsEn)
        );

        setActividadPreseleccionada(entActividadPrincipal);
        setActividadSeleccionada(entActividadPrincipal);
        setLstActividadesSecundariasSeleccionadas(activiadesAdicionalesSeleccionadas);
    };

    useEffect(() => {
        if (entSolicitudDetalleForEdit && lstActividadesCatalogo.length > 0) {
            fnFillFormGiroPrinicpal();
        }
        // eslint-disable-next-line
    }, [entSolicitudDetalleForEdit, lstActividadesCatalogo]);

    return (
        <GiroPrincipalContext.Provider
            value={{
                lstActividadesSecundariasSeleccionadas,
                actividadSeleccionada,
                actividadPreseleccionada,
                modalOpenAsignar,
                modalOpenEliminarGiro,
                actividadSecudariaEliminar,
                modalOpenEliminarActividadSecundaria,
                modalOpenContinuarSinAdicionales,
                actividadCatalogoSeleccionado,
                handleClickAsignarActividad,
                handleCloseAsignar,
                handleCloseEliminarGiro,
                handleClickConfirmarAsignar,
                handleClickEliminarGiro,
                handleClickConfirmarEliminarGiro,
                handleCloseEliminarActividadSecundaria,
                handleCloseContinuarSinAdicionales,
                handleClickEliminarActividadSecundaria,
                handleClickConfirmarEliminarActividadSecundaria,
                handleClickConfirmarContinuarSinAdicionales,
                handleChangeActividadCatalogoSeleccionado,
                handleClickAgregarActividadCatalogo,
                handleClickSiguiente,
                handleClickRegresar,
                handleChangeActividadPreseleccionada,
            }}
        >
            {props.children}
        </GiroPrincipalContext.Provider>
    );
};

export const useGiroPrincipal = function () {
    return useContext(GiroPrincipalContext);
};
